import { formateInputBlurNumber, formateInputNumber } from '@leprecoins/utility';
import { TextInput, Tooltip } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { gameModel } from 'entities/game';
import { ActionIcon, Button, Lighting } from 'shared/ui';
import CoinIcon from 'shared/ui/assets/icons/coin-icon.svg?react';
import CrossIcon from 'shared/ui/assets/icons/cross-icon.svg?react';
import { betMenuModel } from '../../model';
import cls from './bet-menu-wager-field.module.scss';

type BetMenuWagerFieldProps = {
	onReadonlyClick?: () => void;
};

export const BetMenuWagerField = ({ onReadonlyClick }: BetMenuWagerFieldProps) => {
	const { t } = useTranslation();

	const [
		minBet,
		maxBet,
		clear,
		double,
		currency,
		disabled,
		value,
		onChange,
		readOnly,
		enableOnboarding,
		opened,
		isOnboarding,
	] = useUnit([
		gameModel.$minBet,
		gameModel.$maxBet,
		betMenuModel.clearBetButtonClicked,
		betMenuModel.doubleBetButtonClicked,
		gameModel.$currency,
		betMenuModel.$wagerFieldDisabled,
		gameModel.$wager,
		betMenuModel.wagerChanged,
		betMenuModel.$wagerFieldReadOnly,
		betMenuModel.$enableOnboardingWagerField,
		gameModel.$brokeVisible,
		gameModel.$isOnboarding,
	]);

	return (
		<Lighting
			enabled={enableOnboarding}
			className={cls.betMenuWagerFieldLighting}
		>
			<Tooltip
				multiline
				position='top-start'
				opened={opened}
				label={t('bet-menu.no-balance')}
			>
				<TextInput
					id='bet-menu-wager-field'
					disabled={disabled}
					readOnly={readOnly}
					min={minBet}
					max={maxBet}
					leftSectionPointerEvents='none'
					rightSectionPointerEvents='none'
					leftSection={<CoinIcon className={cls.betMenuWagerFieldCoin} />}
					rightSection={
						<>
							<span className={cls.betMenuWagerFieldCurrency}>{currency}</span>
							<ActionIcon
								variant='transparent'
								color='white'
								disabled={disabled}
								tabIndex={readOnly || isOnboarding ? -1 : 0}
								data-onboarding={isOnboarding || undefined}
								onClick={clear}
							>
								<CrossIcon />
							</ActionIcon>
							<Button
								size='sm'
								className={cls.betMenuWagerFieldDouble}
								disabled={disabled}
								tabIndex={readOnly || isOnboarding ? -1 : 0}
								data-onboarding={isOnboarding || undefined}
								onClick={double}
							>
								{t('bet-menu.x2')}
							</Button>
						</>
					}
					value={value}
					classNames={{
						root: cls.betMenuWagerField,
						wrapper: cls.betMenuWagerFieldWrapper,
						section: cls.betMenuWagerFieldSection,
					}}
					onChange={(event) =>
						onChange(formateInputNumber(event.target.value, maxBet, minBet, false, 1))
					}
					onBlur={(event) =>
						onChange(formateInputBlurNumber(event.target.value, maxBet, minBet, true))
					}
					onClick={readOnly ? onReadonlyClick : undefined}
				/>
			</Tooltip>
		</Lighting>
	);
};
